import type { PopoverProps as AriaPopoverProps } from "react-aria-components";
import { Popover } from "react-aria-components";

import { cn } from "@/lib/helpers/cn";

export function Popover2(props: AriaPopoverProps) {
  return (
    <Popover
      className={cn(
        "tw:bg-fill-white",
        "tw:border tw:border-solid tw:border-stroke-tertiary",
        "tw:rounded tw:shadow-lg",
      )}
      {...props}
    />
  );
}
